import * as Sentry from "@sentry/browser";

/**
 * Thin wrapper over the Sentry SDK calls the app makes outside Sentry.init.
 * The SDK is an ES module namespace, which Jasmine cannot spy on, so specs
 * spy on this object instead.
 */
export const sentryClient = {
    captureMessage(
        message: string,
        context?: Parameters<typeof Sentry.captureMessage>[1]
    ): string {
        return Sentry.captureMessage(message, context);
    },
    addBreadcrumb(breadcrumb: Sentry.Breadcrumb): void {
        Sentry.addBreadcrumb(breadcrumb);
    },
};
